@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pointofinterest

import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.routing.domain.passenger.destinations.SearchPassengerPointsEndpoint

object SearchPointsOfInterestEndpoint :
    EndPoint<SearchPointsOfInterestEndpoint.Request, SearchPassengerPointsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String,
        val includeAddress: Boolean,
        val areaId: KmmLong?,
        val priceZoneId: Int?,
    )
}
